import { render, staticRenderFns } from "./PoliticalContributionTable.vue?vue&type=template&id=b7dc4762&scoped=true"
import script from "./PoliticalContributionTable.vue?vue&type=script&lang=js"
export * from "./PoliticalContributionTable.vue?vue&type=script&lang=js"
import style0 from "./PoliticalContributionTable.vue?vue&type=style&index=0&id=b7dc4762&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7dc4762",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7dc4762')) {
      api.createRecord('b7dc4762', component.options)
    } else {
      api.reload('b7dc4762', component.options)
    }
    module.hot.accept("./PoliticalContributionTable.vue?vue&type=template&id=b7dc4762&scoped=true", function () {
      api.rerender('b7dc4762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/compliance/AttestationManager/PoliticalContributionTable.vue"
export default component.exports